module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/desktop_188292.jpg";